module.exports = __webpack_public_path__ + "img/default-user.728368fe.png";